<div
    #container
    class="w-full h-auto bg-p-content-background bp908:rounded-2xl p-4 bp908:shadow-p-form-field-shadow font-inter animate-height-snappy bp908:border bp908:border-p-content-border-color">
    <div
        (click)="onClickTogglePanel()"
        class="w-full flex flex-row justify-between items-center cursor-pointer">
        <div class="text-muted-color font-medium text-14 leading-[normal]"> Groups </div>
        <p-button
            [buttonProps]="{ autofocus: false }"
            size="small"
            class="!w-6 aspect-square"
            styleClass="!w-6 aspect-square"
            severity="secondary"
            [outlined]="true"
            [icon]="groupPanelExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" />
    </div>
    @if (groupPanelExpanded) {
        <div class="w-full flex flex-col justify-start items-start gap-1 animation-fade-in">
            @for (filter of groupFilters; track filter.groupInfo.groupId) {
                <div class="w-full flex justify-start items-center">
                    <p-checkbox
                        [value]="filter.groupInfo.groupId"
                        size="small"
                        [(ngModel)]="filter.show"
                        [binary]="true"
                        [inputId]="filter.groupInfo.groupId"
                        (onChange)="onCheckboxChanged($event)" />
                    <label
                        [for]="filter.groupInfo.groupId"
                        class="w-full ml-2 text-14 leadning-[normal] text-color font-light block truncate"
                        >{{ filter.groupInfo.groupName }}</label
                    >
                </div>
            }
        </div>
    }
</div>
